import { useQueryClient } from '@tanstack/react-query';
import type { ExibicaoEmpresaDto, ExibicaoEmpresaResponse } from '@triade/contracts';
import { useConsulta, useMutacao } from './base';

/** GET /empresa/exibicao: casas decimais de exibicao da empresa (qualquer papel le). */
export function useExibicao() {
  return useConsulta<ExibicaoEmpresaResponse>(['empresa', 'exibicao'], '/empresa/exibicao');
}

/**
 * PUT /empresa/exibicao (parametros.editar). Depois de gravar, TODA consulta em cache e refeita: varios endpoints devolvem
 * valores `exibicao` ja arredondados pela API com as casas da empresa.
 */
export function useSalvarExibicao() {
  const qc = useQueryClient();
  const m = useMutacao<ExibicaoEmpresaResponse, ExibicaoEmpresaDto>({
    metodo: 'PUT',
    caminho: () => '/empresa/exibicao',
    corpo: (v) => v,
  });
  return {
    ...m,
    mutateAsync: async (v: ExibicaoEmpresaDto) => {
      const r = await m.mutateAsync(v);
      qc.setQueriesData({ queryKey: ['empresa', 'exibicao'] }, r);
      await qc.invalidateQueries({ predicate: (q) => !(q.queryKey[0] === 'empresa' && q.queryKey[1] === 'exibicao') });
      return r;
    },
  };
}
